// WhatsOn Immediate section class

function processImmediateSections() {
    // Find .troxy-whatson-immediate-section
    var immediateSections = document.querySelectorAll('.troxy-whatson-immediate-section');
  
    // Check if immediateSections exist
    if (immediateSections.length > 0) {
        // Loop through each immediate section
        immediateSections.forEach(function(section) {
            // Find .troxy-whatson-card inside current section
            var cards = section.querySelectorAll('.troxy-whatson-card');
            
            // Initialize variables to track presence of data-today and data-tomorrow attributes
            var hasToday = false;
            var hasTomorrow = false;
            
            // Check each .troxy-whatson-card within the section for data-today or data-tomorrow attributes
            cards.forEach(function(card) {
                if (card.hasAttribute('data-today')) {
                    hasToday = true;
                }
                if (card.hasAttribute('data-tomorrow')) {
                    hasTomorrow = true;
                }
            });
            
            // Add appropriate class based on conditions
            if (hasToday && hasTomorrow) {
                section.classList.add('both');
            } else if (hasToday) {
                section.classList.add('today');
            } else if (hasTomorrow) {
                section.classList.add('tomorrow');
            }
        });
    }
  }
  
  // Call the function if .troxy-whatson-immediate-section exists on the page
  document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.troxy-whatson-immediate-section')) {
        processImmediateSections();
    }
  });